import { render, staticRenderFns } from "./CourseCert.vue?vue&type=template&id=0f0a0c71&scoped=true&"
import script from "./CourseCert.vue?vue&type=script&lang=js&"
export * from "./CourseCert.vue?vue&type=script&lang=js&"
import style0 from "./CourseCert.vue?vue&type=style&index=0&id=0f0a0c71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0a0c71",
  null
  
)

export default component.exports